import { Component } from "@angular/core";

@Component({
    selector: 'app-auth',
    template: `
        <div class="main">
            <router-outlet></router-outlet>
        </div>`,
    styleUrls: []
})
export class AuthComponent {

}
